// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b1d0992f","403":"32010704","800":"0a05843b"}[chunkId] + ".chunk.js";
};